import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { User } from '@sabstravtech/obtservices/angular';
import { DifferentTraveller } from '@sabstravtech/obtservices/base';

import { LightningModalTypes } from '../../core/classes/modal-types.enum';

@Component({
  selector: 'app-different-traveller-per-basket',
  templateUrl: './different-traveller-per-basket.component.html',
  standalone: false
})
export class DifferentTravellerPerBasketComponent {
  // Inputs provided by caller.
  userInBasket: User[] = null;
  travellers: User[] = null;

  // Other fields
  DifferentTraveller = DifferentTraveller;

  constructor(public activeModal: NgbActiveModal) {}
}

LightningModalTypes.DifferentTravellerPerBasketComponent.component =
  DifferentTravellerPerBasketComponent;
